<template>
    <div class="extended-panel details-panel routed-extended-page">
        <planner-panel v-if="truck" class="side-panel-fill" :truck="truck" @lostfocus="goToTruckDetails" />
    </div>
</template>

<script>
import PlannerPanel from '@/components/panels/PlannerPanel.vue'
import truckPageGuard from '@/mixins/truckPageGuard'

export default {
    name: 'RoutePage',
    mixins: [truckPageGuard],
    components: { PlannerPanel }
}
</script>
